import { memo } from 'react';
import { Checkbox, Group, Stack, Text } from '@mantine/core';

// Memoized cut selection checkboxes
export const CutSelectionCheckboxes = memo(
  ({
    selectedCuts,
    onCutsChange,
  }: {
    selectedCuts: string[];
    onCutsChange: (cuts: string[]) => void;
  }) => (
    <Stack gap="xs" mt="sm" ml="xl">
      <Text size="sm" fw={500}>
        Sélectionner les vues concernées :
      </Text>
      <Group gap="xs">
        {['AA', 'BB', 'CC', 'DD', 'EE', 'FF'].map(cut => (
          <Checkbox
            key={cut}
            checked={selectedCuts.includes(cut)}
            onChange={event => {
              if (event.currentTarget.checked) {
                onCutsChange([...selectedCuts, cut]);
              } else {
                onCutsChange(selectedCuts.filter(c => c !== cut));
              }
            }}
            label={cut}
            size="sm"
          />
        ))}
      </Group>
    </Stack>
  ),
);

CutSelectionCheckboxes.displayName = 'CutSelectionCheckboxes';
